import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ actionKey, id }) => {
  switch (actionKey) {
  case 1:
    return (
      <div className="text-center">
        Delete message
      </div>
    );

  case 2:
    return (
      <div className="text-center">
        Delete ticket (Ticket ID:
        {' '}
        {id}
        )
      </div>
    );

  case 3:
    return (
      <>
        <div className="text-center">
          Close and lock ticket
        </div>
        <div className="text-center">
          (Ticket ID:
          {' '}
          {id}
          )

        </div>
      </>
    );

  case 4:
    return (
      <div className="text-center">
        Close ticket (Ticket ID:
        {' '}
        {id}
        )
      </div>
    );

  case 5:
    return (
      <div className="text-center">
        Mark as spam ticket (Ticket ID:
        {' '}
        {id}
        )
      </div>
    );

  default:
    return '';
  }
};

Title.propTypes = {
  actionKey: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Title;
